/**
 * Pure presentation helpers for course authors. (Author *data* lives in the
 * lookups slice — see features/lookups/lookupsSlice.ts.)
 */

import { CourseAuthor } from '../apis/api-client';

/**
 * CSS `object-position` for an author portrait, defaulting to centered when
 * no focal point is saved. Clamped to 0–100%.
 */
export function getPortraitObjectPosition(author: CourseAuthor | null | undefined): string {
  const x = Math.max(0, Math.min(100, author?.portraitFocalX ?? 50));
  const y = Math.max(0, Math.min(100, author?.portraitFocalY ?? 50));
  return `${x}% ${y}%`;
}
